import image191100AudienceWide from '../msan-image-ad/image-191-100-audience-wide';
import image178100EdgeSingle from '../msan-image-ad/image-178-100-edge-single';
import image150100MSNInArticle from '../msan-image-ad/image-150-100-msn-in-article';
import image133100MSNSmall from '../msan-image-ad/image-133-100-msn-small';
import image11AudienceSquare from '../msan-image-ad/image-1-1-audience-square';
import windowsSpotlight from './image-windows-spotlight';
import discover from './image-discover';
import startMenu from './image-start-menu';
import actionCenter from './image-action-center';
import banner from './image-banner';
import imageProng from './image-prong';
import imageCoachMark from './image-coachmark';

export const msanBoostImageAdTemplates = [
  image191100AudienceWide,
  image178100EdgeSingle,
  image150100MSNInArticle,
  image133100MSNSmall,
  image11AudienceSquare,
  windowsSpotlight,
  discover,
  startMenu,
  actionCenter,
  banner,
  imageProng,
  imageCoachMark,
];
